import { VersionHistoryList } from '@dataroom/shared';
import { useDocumentVersions, useSplitDocumentVersion } from '@/api/hooks';

/**
 * The review panel's VERSION HISTORY (ADR-0031): every version of the document
 * with Open / Download, and "Split back out" for a version that came in with a
 * merge (the room admin's undo). Owns its query and the split.
 */
export function DocumentVersionHistory({
  roomId,
  documentId,
}: {
  roomId: string;
  documentId: string;
}) {
  const versions = useDocumentVersions(roomId, documentId);
  const split = useSplitDocumentVersion(roomId);
  return (
    <VersionHistoryList
      roomId={roomId}
      documentId={documentId}
      versions={versions.data}
      error={versions.error}
      onSplit={(versionId) => split.mutate({ documentId, versionId })}
      splittingId={split.isPending ? (split.variables?.versionId ?? null) : null}
      splitError={split.error}
    />
  );
}
